import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useCatalog, MAX_QTY } from "@/components/campaign/ServiceCatalog";

const KEY = "aurora_cart";
const CartContext = createContext(null);

const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(load);
  const catalog = useCatalog();
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(cart)); }, [cart]);
  useEffect(() => {
    if (!catalog) return;
    const ok = new Set(catalog.filter((i) => !(i.price_max > i.price)).map((i) => i.id));
    setCart((c) => (Object.keys(c).every((id) => ok.has(id)) ? c : Object.fromEntries(Object.entries(c).filter(([id]) => ok.has(id)))));
  }, [catalog]);
  const setQty = useCallback((id, q) => setCart((c) => {
    const n = { ...c };
    if (q > 0) n[id] = Math.min(MAX_QTY, q); else delete n[id];
    return n;
  }), []);
  const clear = useCallback(() => setCart({}), []);
  return <CartContext.Provider value={{ cart, setQty, clear, catalog }}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
